import React, {useState} from 'react';
 
import { Form, Button, Row, Col, ListGroup, Table, ButtonGroup } from "react-bootstrap";
 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons"; 
import ImageUploading from 'react-images-uploading';
 
import ToggleButton from 'react-bootstrap/ToggleButton'


import Rightbar from './Rightbar';

export default function UpdateArtWork(){ 
    const [radioValue, setRadioValue] = useState('1');
  
    const radios = [
      { name: 'INCHES', value: '1' },
      { name: 'CENTIMETERS', value: '2' }
    ];
const [images, setImages] = React.useState([]);
const maxNumber = 69;

const onChange = (imageList, addUpdateIndex) => {
// data for submit
console.log(imageList, addUpdateIndex);
setImages(imageList);
};
const [sidebar, setsidebar] = useState(false);
const [mainbar, setmainbar] = useState(false);
const toggle = () => {
setsidebar(!sidebar);
setmainbar(!mainbar);
}
return(
<>
<section className="sec-container" >
<div className='container'>
<div className='portalevent'>
<div className='row'>
<div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
<div >
<Rightbar/>
</div>
</div>
<div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
<div className='rightbar '>
<Button variant="outline-info" onClick={toggle}>
<FontAwesomeIcon icon={faAlignLeft} />
</Button>
<div className='add-post'>
<h1>UPDATE ARTWORK</h1>
<div className='gry-bg'>
<p>
                                File Specifications: jpg, sRGB, 72 dpi, {'<='}2MB<br />
                                File names cannot any apostrophes or special characters ({'" @ \ / | : < > *'}).
                            </p>
                            <p>
                                Artworks must be photographic images between 6-168 in (16-428 cm) in height and width.
                            </p>
</div>


<div className='row'>      
<div className='col-md-8 col-12'>
<Form>
                                <Row>
                                    <Col>
                                        <Form.Group  className="mb-3" controlId="formHorizontalEmail">
                                            <Form.Label > Artist  </Form.Label>
                                            <Form.Control type="text" placeholder="Kellye" />
                                        </Form.Group>
                                        <Form.Group  className="mb-3" controlId="formHorizontalEmail">
                                            <Form.Label > Title  </Form.Label>
                                            <Form.Control type="text" placeholder="Untitled" />
                                        </Form.Group>
                                        <Form.Group  className="mb-3" controlId="formHorizontalEmail">
                                            <Form.Label > Medium  </Form.Label>
                                            <Form.Control type="text" placeholder="Silver gelatin print" />
                                        </Form.Group>
                                        <Form.Group  className="mb-3" controlId="formHorizontalEmail">
                                            <Form.Label > Edition  </Form.Label>
                                            <Form.Control type="text" placeholder="1 of 3" />
                                        </Form.Group>
                                    </Col>
                                     
                                </Row>
                                
                                <Row>
                                    <Col>
                                        <Form.Group  className="mb-3" controlId="formHorizontalEmail">
                                            <Form.Label > Year  </Form.Label>
                                            <Form.Control type="text" placeholder="2021" />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group  className="mb-3" controlId="formHorizontalEmail">
                                            <Form.Label > Price (USD)  </Form.Label>
                                            <Form.Control type="text" placeholder="90.00" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Size</Form.Label><br />
                                            <ButtonGroup>
                                                {radios.map((radio, idx) => (
                                                <ToggleButton
                                                    key={idx}
                                                    id={`radio-${idx}`}
                                                    type="radio"
                                                    variant={idx % 2 ? 'outline-info' : 'outline-info'}
                                                    name="radio"
                                                    value={radio.value}
                                                    checked={radioValue === radio.value}
                                                    onChange={(e) => setRadioValue(e.currentTarget.value)}
                                                >
                                                    {radio.name}
                                                </ToggleButton>
                                                ))}
                                            </ButtonGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Row>
                                            <Col>
                                                <Form.Group  className="mb-3" controlId="formHorizontalEmail">
                                                    <Form.Label > Height  </Form.Label>
                                                    <Form.Control type="text" placeholder="10" />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group  className="mb-3" controlId="formHorizontalEmail">
                                                    <Form.Label > Width  </Form.Label>
                                                    <Form.Control type="text" placeholder="8" />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        
                                    </Col>
                                </Row>
 
                            </Form>
</div>
<div className='col-md-4 col-12 middle-aln'>
<img variant="top" className='img-responsive' src={process.env.PUBLIC_URL+'/images/update-artwork.jpg'} /> 
</div>
</div> <hr/>
<div className='text-center'>
<Button className='common-btn'>SAVE</Button>{' '}
<Button className='cancel-btn'>CANCEL</Button>{' '}
<Button className="delete-btn">Delete</Button>{' '}
</div>
 <br/>
</div>
</div>
</div>
</div>
</div>
</div>
</section>  


</>
)
}
